export default __webpack_public_path__ + "static/media/Poppinspoppins-semiboldmedium.3dba38ec.ttf";